export default {
  SET_ACTIVE_BLOCKCHAIN(state, payload) {
    state.activeBlockchain = payload
  },
  SET_RANGE_FILTER(state, payload) {
    state.rangeFilter = payload
  },
  SET_RISK_FILTER(state, payload) {
    state.riskFilter = payload
  },
  SET_SOURCE_FILTER(state, payload) {
    state.sourceFilter = payload
  },
}
